
import { SplitType, GuidEmpty, Steps } from "../../../lib/constants";

export default (props, bill, customer, splitBillSessionToken) => {
  const splitType = bill.splitBill.splitType;
  if (splitType === SplitType.None) return;

  const splits = bill.splitBill.splits;

  let customerId = !!customer ? customer.id : null;
  let assignedSplitIndex = null;
  let hasExistingPaidSplit = false;

  if (customerId !== null) {
    for (let i = 0; i < splits.length; i++) {
      if (splits[i].pizzaExpressId === customerId) {
        if (splits[i].paid === false) {
          assignedSplitIndex = i;
          break;
        } else {
          hasExistingPaidSplit = true;
        }
      }
    }
  }

  if (assignedSplitIndex === null) {
    for (let i = 0; i < splits.length; i++) {
      if (splits[i].sessionToken === splitBillSessionToken) {
        if (splits[i].paid === false) {
          assignedSplitIndex = i;
          break;
        } else {
          hasExistingPaidSplit = true;
        }
      }
    }
  }

  props.setAssignedSplitIndex(assignedSplitIndex);
  props.setSelectedSplitIndex(assignedSplitIndex);

  const newSplitsAvailable = splitType === SplitType.SplitByItem || (splitType === SplitType.SplitByAmount && splits.some(s => s.sessionToken === GuidEmpty));
  if (assignedSplitIndex === null && hasExistingPaidSplit === false && newSplitsAvailable === true) {
    props.goToStep(Steps.SPLIT_BILL_NAME)
  }
}